import { useState } from "react";
import { Input, Form, Modal, Typography } from "antd";

import { createItem, updateItem } from "@/api/users";

const { Text } = Typography;

// Окно для создания/редактирования пользователя, содержит форму
const UserModal = ({ data, visible, onSave, onCancel }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const initialValue = {
    ...data,
  };

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    const res = { ...values };

    try {
      if (data.uuid) {
        await updateItem({ ...data, ...res });
      } else {
        await createItem(res);
      }
      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () =>
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });

  return (
    <Modal
      maskClosable={false}
      title={
        data.uuid
          ? "Редактирование пользователя"
          : "Добавление нового пользователя"
      }
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText={data.uuid ? "Сохранить" : "Добавить"}
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValue}
        onFinish={handleSave}
      >
        <Form.Item
          name="email"
          label="Логин"
          rules={[
            {
              required: true,
              message: "Пожалуйста, введите логин пользователя",
            },
          ]}
        >
          <Input />
        </Form.Item>

        {(!data || !data.uuid) && (
          <Form.Item
            name="password"
            label="Пароль"
            rules={[
              {
                required: true,
                message: "Пожалуйста, введите пароль пользователя",
              },
            ]}
          >
            <Input />
          </Form.Item>
        )}

        {error && <Text type="danger">{error}</Text>}
      </Form>
    </Modal>
  );
};

export default UserModal;
